// extracted by mini-css-extract-plugin
export default {"container":"Tag_container__e6aHO","multiline":"Tag_multiline__7Np5U","ellipsis":"Tag_ellipsis__X3FoF","cross":"Tag_cross__BbaH4"};